<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import { required } from "vuelidate/lib/validators";
import pensionTrabajadoresAPI from "@/services/standards/pensionTrabajadores/pensionTrabajadoresAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import PensionPagination from "@/components/standard/pensionTrabajadores/PensionPagination";
import { sendNotification } from "@/utils/helpers/notification";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import ItemAPI from "@/services/items/itemsAPI";
import { dateFormat2 } from "@/utils/helpers/format";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Pago de Pensión Trabajadores de Alto Riesgo",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    CheckModal,
    PageHeader,
    PensionPagination,
  },
  data() {
    return {
      title: "1.1.5 Pago de Pensión Trabajadores de Alto Riesgo ",
      items: [
        {
          text: "Estándares",
          href: "/",
        },
        {
          text: "Pago de Pensión Trabajadores de Alto Riesgo ",
          active: true,
        },
      ],
      userSelected: null,
      usersList: [],
      lista: [],
      search: "",
      validateListIdOne: 'La Empresa no cuenta con trabajadores con actividades de Alto Riesgo.',

      item: null,
      itemStatus: "No cumplido",
      deleteCount: 0,
      itemData: null,

      file: null,
      listaII: null,
      ocupationalMedicine: {
        id: null,
        exam_date: null,
        file: null,
        exam_cycles_id: 1,
        employee_id: null,
        archivo: null,
        exam_status: 0,
      },

      pensionTrabajadores: {
        activities: null,
        file: null,
        period: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      submitted: false,
      nit: this.$store.getters["company/getCompany"].nit || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      loading: true,

      period: [
        {
          id: 1,
          name: "Mes",
        },
        {
          id: 1,
          name: "Año",
        },
      ],

      list: [
        {
          id: 1,
          name: "La Empresa no cuenta con trabajadores con actividades de Alto Riesgo.",
        },
        {
          id: 2,
          name: "Trabajos en minería que impliquen prestar el servicio en socavones o en subterráneos.",
        },
        {
          id: 3,
          name: " Trabajos que impliquen la exposición a altas temperaturas, por encima de los valores límites permisibles, determinados por las normas técnicas de salud de salud ocupacional.",
        },
        {
          id: 4,
          name: "Trabajos con exposición a radiaciones ionizantes",
        },
        {
          id: 5,
          name: "Trabajos con exposición a sustancias comprobadamente cancerígenas.",
        },
        {
          id: 6,
          name: "En la Unidad Administrativa Especial de Aeronáutica Civil o la entidad que haga sus veces, la actividad de los técnicos aeronáuticos con funciones de controladores de tránsito aéreo, con licencia expedida o reconocida por la Oficina de Registro de la Unidad Administrativa Especial de Aeronáutica Civil, de conformidad con las normas vigentes.",
        },
        {
          id: 7,
          name: "En los Cuerpos de Bomberos, la actividad relacionada con la función específica de actuar en operaciones de extinción de incendios.",
        },
        {
          id: 8,
          name: "En el Instituto Nacional Penitenciario y Carcelario, Inpec, la actividad del personal dedicado a la custodia y vigilancia de los internos en los centros de reclusión carcelaria, durante el tiempo en el que ejecuten dicha labor. Así mismo, el personal que labore en las actividades antes señaladas en otros establecimientos carcelarios, con excepción de aquellos administrados por la fuerza pública.",
        },
      ],
    };
  },
  validations: {
    pensionTrabajadores: {
      activities: {
        required,
      },
      file: {
        required,
      },
      period: {
        required,
      },
      employee_id: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(5)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    fetch() {
      this.$refs.paginator.query();
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/1.1.5/${this.pensionTrabajadores.employee_id}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/1.1.5/${this.pensionTrabajadores.employee_id}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.pensionTrabajadores.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getList() {
      pensionTrabajadoresAPI
        .getPension(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          this.lista = response.Prevention_brigades.data;
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    async save() {
      this.submitted = true;
      this.loading = true
      if (this.pensionTrabajadores.activities === this.list[0].name) {
        pensionTrabajadoresAPI.save(this.pensionTrabajadores)
          .then((response) => {
            this.sendNotification(45, 5, true);
            const itemChange = {
              companies_id: this.companyID,
              item_id: 5,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                }, 2000);
                window.location.reload();
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        let response = await this.uploadDocument();
        if (response) {
          pensionTrabajadoresAPI.save(this.pensionTrabajadores)
            .then((response) => {
              this.sendNotification(45, 5, true);
              const itemChange = {
                companies_id: this.companyID,
                item_id: 5,
                status: 'Pendiente',
              };
              newScoresAPI.calculateScores(itemChange)
                .then((response) => {
                  this.loading = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "¡Éxito!",
                      text: "¡Se ha registrado con éxito!",
                      icon: "success",
                      type: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                  }, 2000);
                  window.location.reload();
                })
                .catch((error) => {
                  this.loading = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "Error",
                      text: "¡No se ha podido registrar!",
                      icon: "error",
                      type: "error",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 1000);
                  console.log(error);
                });

            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.loading = false
          setTimeout(() => {
            Swal.fire({
              text: "error",
              title: "¡No se ha podido registrar!",
              icon: "warning",
              type: "error",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
          }, 2000)
        }
      }
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              this.usersList = res.employee;
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    dateConvert(date) {
      return dateFormat2(date);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    deletePension(id) {
      pensionTrabajadoresAPI
        .delete(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';

          const itemChange = {
            companies_id: this.companyID,
            item_id: 5,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "¡Éxito!",
                text: "Se ha sido eliminado con exito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading1 = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 5)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 5,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },
  },

  mounted() {
    this.getUsers();
    this.getList();
    this.getItems();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      Se debe seleccionar las actividades de alto riesgo
                      mencionadas en el Decreto 2090 de 2003, que se realizan en
                      la empresa, en caso de no realizarlas, se seleccionará la
                      opción: La Empresa no cuenta con trabajadores con
                      actividades de Alto Riesgo.
                    </p>
                    <p class="text-justify">
                      Una vez seleccionada la actividad, se debe indicar cuales
                      son los colaboradores que realizan dichas actividades y
                      posteriormente, subir las evidencias del pago de pensiones
                      de cada uno de éstos.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <hr>

              <form class="form-group px-4" @submit.prevent="save">
                <b-form-group id="cycle" label-for="cycle" class="col-md-10 px-2"
                  label="Listado de las actividades consideradas como alto riesgo">
                  <table
                    class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded style=overflow-y: scroll;">
                    <tbody class="bg-white divide-y divide-gray-200">
                      <tr v-for="dato in list" :key="dato.id" :value="dato.name">
                        <td>
                          {{ dato.name }}
                        </td>
                        <td class="text-center align-middle">
                          <input type="radio" style="color: #666" :value="dato.name"
                            v-model="pensionTrabajadores.activities" class="mb-2 mr-sm-2 mb-sm-0" label="accidente" />
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </b-form-group>

                <div v-if="list.id === 1" class="form-row pt-3">
                  <b-form-group label-for="employee" class="col-md-4 px-2" label="Colaborador">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="pensionTrabajadores.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }} - {{ item.contract_type.name }}
                      </b-form-select-option>
                    </select>
                    <div v-if="submitted && $v.pensionTrabajadores.employee_id.$error">
                      <small v-if="!$v.pensionTrabajadores.employee_id.required" class="text-danger">
                        <b>El colabodor es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-4 px-2" label="Periodo" label-for="Periodo">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="endDate"
                      v-model="pensionTrabajadores.period">
                    </b-form-input>
                    <div v-if="submitted && $v.pensionTrabajadores.period.$error">
                      <small v-if="!$v.pensionTrabajadores.period.required" class="text-danger">
                        <b>El periodo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-4 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      browse-text="Buscar" :placeholder="`Selecciona un archivo...`" drop-placeholder="Suelta acá..."
                      v-model="file" @change="uploadFile" v-on:change="uploadFile">
                    </b-form-file>
                    <div v-if="submitted && $v.pensionTrabajadores.uploadFile.$error">
                      <small v-if="!$v.pensionTrabajadores.uploadFile.required" class="text-danger">
                        <b>El campo archivo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>
                <div v-else class="form-row pt-3">
                  <b-form-group label-for="employee" class="col-md-4 px-2" label="Colaborador">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="pensionTrabajadores.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }} - {{ item.contract_type.name }}
                      </b-form-select-option>
                    </select>
                    <div v-if="submitted && $v.pensionTrabajadores.employee_id.$error">
                      <small v-if="!$v.pensionTrabajadores.employee_id.required" class="text-danger">
                        <b>El colabodor es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-4 px-2" label="Periodo" label-for="Periodo">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="endDate"
                      v-model="pensionTrabajadores.period">
                    </b-form-input>
                    <div v-if="submitted && $v.pensionTrabajadores.period.$error">
                      <small v-if="!$v.pensionTrabajadores.period.required" class="text-danger">
                        <b>El periodo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-4 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                    <div v-if="submitted && $v.pensionTrabajadores.file.$error">
                      <small v-if="!$v.pensionTrabajadores.file.required" class="text-danger">
                        <b>El campo archivo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr v-if="getRole('Consultar') || !allowAccess()" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <form @submit.prevent="fetch()" class="form-inline">
                            <div class="form-group mr-2">
                              <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                class="form-control px-2" placeholder="Buscar"></b-form-input>

                              <div class="col-1">
                                <button type="submit" class="btn btn-primary px-2">
                                  Buscar
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <thead>
                            <tr>
                              <th>Fecha creación</th>
                              <th>Periodo</th>
                              <th class="text-center align-middle">Colaborador</th>
                              <th class="text-center align-middle">Tipo de empleado</th>
                              <th class="text-center align-middle">Documento</th>
                              <th class="text-center align-middle">Ver archivo</th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody v-if="this.item.status === 'Aprobado'" class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">

                              <td>{{ dateConvert(dato.created_at) }}</td>
                              <td>{{ dateConvert(dato.period) }}</td>
                              <td class="text-center align-middle">{{ dato.full_name }}</td>
                              <td class="text-center align-middle">
                                <div v-if="dato.contract_type_id === 1">
                                  <h6>Planta</h6>
                                </div>
                                <div v-if="dato.contract_type_id === 3">
                                  <h6>Contratista</h6>
                                </div>
                                <div v-if="dato.contract_type_id === 2">
                                  <h6>Aprendiz</h6>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div v-if="dato.file">
                                  <h6>Soporte de pago</h6>
                                </div>
                                <div v-else>
                                  <h6>N/A</h6>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div v-if="dato.file === null">
                                  <h6>No hay archivo disponible</h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()" style="
                                      background-color: transparent !important;
                                      border: none;
                                    " type="button" @click="gotoDigitalOcean(`${dato.file}`)">
                                    <i class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>

                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                      " v-b-modal="`modal${dato.id}`">
                                      Editar</b-dropdown-item>

                                    <b-modal :id="`modal${dato.id}`" body-class="p-4" hide-header hide-footer size="sm">
                                      <div class="text-justify">
                                        <h4 class="mt-2 text-primary text-center">
                                          Advertencia
                                        </h4>
                                        <p class="mt-3">
                                          Al modificar esta información se
                                          quitará el puntaje correspondiente a
                                          este ítem y será necesario realizar
                                          nuevamente la validación por parte del
                                          usuario responsable de Emisión.
                                        </p>
                                        <button :disabled="!getRole('Editar') || !allowAccess()
                                          " type="button" class="btn btn-primary my-2 mx-2">
                                          <router-link class="text-white" :to="{
                                            path: `/forms/estandares/pension-trabajadores-alto-riesgo-editar/${dato.id}`,
                                          }">Editar
                                          </router-link>
                                        </button>
                                        <button type="button" @click="
                                          $bvModal.hide(`modal${dato.id}`)
                                          " class="btn btn-danger btn mx-2" data-dismiss="modal">
                                          Cancelar
                                        </button>
                                      </div>
                                    </b-modal>
                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                      " v-on:click="deletePension(dato.id)">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>
                          </tbody>

                          <tbody v-else class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">

                              <td>
                                <div v-if="dato.created_at">
                                  {{ dateConvert(dato.created_at) }}
                                </div>
                                <div v-else>
                                  N/A
                                </div>
                              </td>

                              <td>
                                <div v-if="dato.period">
                                  {{ dateConvert(dato.period) }}
                                </div>
                                <div v-else>
                                  N/A
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div v-if="dato.full_name">
                                  {{ dato.full_name }}
                                </div>
                                <div v-else>
                                  N/A
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div v-if="dato.contract_type_id === 1">
                                  <h6>Planta</h6>
                                </div>
                                <div v-if="dato.contract_type_id === 3">
                                  <h6>Contratista</h6>
                                </div>
                                <div v-if="dato.contract_type_id === 2">
                                  <h6>Aprendiz</h6>
                                </div>
                                <div v-if="dato.contract_type_id === null">
                                  N/A
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div v-if="dato.file">
                                  <h6>Soporte de pago</h6>
                                </div>
                                <div v-else>
                                  <h6>N/A</h6>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div v-if="dato.file === null">
                                  <h6>No hay archivo disponible</h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()" style="
                                      background-color: transparent !important;
                                      border: none;
                                    " type="button" @click="gotoDigitalOcean(`${dato.file}`)">
                                    <i class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>

                                    <div v-if="dato.full_name != null">
                                      <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                        " :to="{
                                          path: `/forms/estandares/pension-trabajadores-alto-riesgo-editar/${dato.id}`,
                                        }">
                                        Editar</b-dropdown-item>
                                    </div>

                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                      " v-on:click="deletePension(dato.id)">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <PensionPagination ref="paginator" :search="search" @fetch="(items) => (lista = items)" />
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
